import { Box, ColorOptions, convertHexToRGBA, Icon, Loader, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { SodexoIcon } from '../../assets/images/svg/Sodexo'
import { Button } from '../../comps/Button'
import { CreditCard } from '../../comps/CreditCard'
import { CardType } from '../../data/models/Card'
import { useLazyApiData, useStores } from '../../data/store'
import { Header } from '../../nav/PayStack'
import { isIFrame } from '../../utils'
import { PAYMENT_MODE_SUBTYPES, windowConfig } from '../../utils/constants'
import { staticStrings } from '../../utils/string'
import { MobileProcessing } from '../PaymentProcesseing/MobileProcessing'
import { CardData } from '../SavedCard/types'
import { FoodCardFullScreenProcessing } from './FoodCardFullScreenProcessing'
import styles from './styles'
import Pluxee from '../../assets/images/svg/Pluxee'
// const Loader = ({ state, onRetry, message, show = false, theme }: any) => {
//   return <EmptyView state={state} onRetry={onRetry} message={message} show={show} theme={theme} />
// }

const FoodCard: FC = () => {
  const [showAddeNew, setShowAddeNew] = useState(false)
  const [prevLength, setPrevLength] = useState<number | undefined>()
  // const [showConfirmationAlert, setConfirmationAlert] = useState(false)
  // const [selected, setSelected] = useState('')
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  // const [cards, setCards] = useState<CardData[]>([])
  const postDataRef = useRef<any>()

  const {
    // binService,
    intentId,
    amount,
    addCardPaymentMethod,
    theme,
    closeModal,
    updateModalDisplaying,
    updateCancelModal,
    getSavedCards,
    savedCardApiStatus,
    getFoodCards,
    getNoBalanceCardTokens,
    setSelectedPayment,
    getInstruments,
    getInstrumentsList,
    template,
    isValidTemplate,
    updateHeaderClose,
    isSinglePaymentModeAllowed,
    redirectUrl,
    getCardBalance,
    uniqueWindowId,
  } = useStores((root) => ({
    // binService: root.binServiceApi,
    intentId: root.transaction.id.intentId,
    amount: root.getTransactionAmount(),
    addCardPaymentMethod: root.transaction.addPaymentMethod,
    theme: root?.config?.merchantTheme,
    closeModal: root.config.closeModal,
    updateModalDisplaying: root.config.updateModalDisplaying,
    updateCancelModal: root.config.updateCancelModal,
    getSavedCards: root.getSavedCards,
    savedCardApiStatus: root.config.savedCardApiStatus,
    getFoodCards: root.getFoodCards,
    cardsLength: root.user.paymentMethod.length,
    setSelectedPayment: root.setSelectedPayment,
    getInstruments: root.getInsturmentsApi,
    getInstrumentsList: root.getInstrumentsList,
    template: root.merchant.template,
    isValidTemplate: root.isValidTemplate,
    updateHeaderClose: root.config.updateHeaderClose,
    isSinglePaymentModeAllowed: root.merchant.isSinglePaymentModeAllowed,
    redirectUrl: root.transaction.initiatingEntity.returnUrl,
    getCardBalance: root.getCardBalance,
    getNoBalanceCardTokens: root.getNoBalanceCardTokens,
    refreshFoodCards: root.user.refreshFoodCards,
    uniqueWindowId: root.config.uniqueWindowId,
  }))

  const { goBack, canGoBack } = useNavigation()
  // const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.CARD)
  const savedCards = getFoodCards() ?? []
  console.log('FoodCard savedCards: ', savedCards, savedCardApiStatus)
  const noSavedCards = savedCardApiStatus === 'done' && savedCards?.length === 0
  const savedCardsAvailable = savedCardApiStatus === 'done' && savedCards?.length !== 0
  const [isSavedCardVisible, setIsSavedCardVisible] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [isAddNewFoodCard, setIsAddNewFoodCard] = useState(false)
  const [isDisabled, setIsDisabled] = useState(false)
  const [lazyGetSavedCards, { state: savedCardsState }] = useLazyApiData(getSavedCards)
  const [lazyInsrtumentsApi, { state: instrumentsApiState, data: instrumentsApiData }] = useLazyApiData(getInstruments)
  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  useEffect(() => {
    if (noSavedCards) {
      console.log('FoodCard noSavedCards: ', noSavedCards)
      console.log('FoodCard calling lazyInstrumentsApi')
      lazyInsrtumentsApi(PAYMENT_MODE_SUBTYPES.FOOD_CARD)
    } else if (savedCardsAvailable) {
      const [firstCard, secondCard] = getNoBalanceCardTokens()
      console.log('🚀 ~ file: index.tsx ~ line 97 ~ useEffect ~ secondCard', secondCard)
      console.log('🚀 ~ file: index.tsx ~ line 97 ~ useEffect ~ firstCard', firstCard)
      if (firstCard) {
        getCardBalance(firstCard)
      }
      if (secondCard) {
        getCardBalance(secondCard)
      }
    }
  }, [getCardBalance, getFoodCards, getNoBalanceCardTokens, lazyInsrtumentsApi, noSavedCards, savedCardsAvailable])

  useEffect(() => {
    console.log('FoodCard useEffect savedCardApiStatus', savedCardApiStatus)
    if (savedCardApiStatus === 'initial') {
      console.log('FoodCard useEffect calling lazyGetSavedCards')
      lazyGetSavedCards()
    }
  }, [lazyGetSavedCards, savedCardApiStatus])

  const loadProcessingScreen = useCallback(() => {
    console.log('FoodCard loadProcessingScreen')
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
    console.log('FoodCard setShowPaymentProcessModal true')
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  useEffect(() => {
    if (closeModal) {
      updateModalDisplaying(false)
      setShowAddeNew(false)
      updateCancelModal(false)
    }
  }, [closeModal, updateCancelModal, updateModalDisplaying])

  const handleNoSavedFoodCardsFlow = useCallback(
    (foodCardProvider: string) => {
      const foodCardProviders = getInstrumentsList(PAYMENT_MODE_SUBTYPES.FOOD_CARD)
      const foodCardProvidersKey = 'Other banks' //TODO: change as per api
      const foodCardInstrumentsList =
        (foodCardProviders && foodCardProviders?.find((item: any) => item.title === foodCardProvidersKey)) ?? []
      const selectedItem = foodCardInstrumentsList?.data?.find((item: any) => item?.id === foodCardProvider)?.id
      console.log('FoodCard handleNoSavedFoodCardsFlow selectedItem', foodCardProvider, selectedItem)
      setSelectedPayment(selectedItem, PAYMENT_MODE_SUBTYPES.FOOD_CARD)
      loadProcessingScreen()
    },
    [getInstrumentsList, loadProcessingScreen, setSelectedPayment],
  )

  useEffect(() => {
    if (instrumentsApiState === 'fulfilled') {
      handleNoSavedFoodCardsFlow('4000')
    } else if (instrumentsApiState === 'rejected') {
      setErrMsg(
        instrumentsApiData?.message ??
          'Sorry, your payment got declined by Pluxee, try using a different payment method',
      )
    }
  }, [handleNoSavedFoodCardsFlow, instrumentsApiData, instrumentsApiState])

  // Method to pass in onPayment prop of Credit Card Component
  const proceedWithPayment = ({
    cardNumber,
    cardHolderName,
    expiry,
    cvv,
    isSaveCard,
    token,
    type,
    scheme,
    isNewCard,
  }: any) => {
    console.log('FoodCard proceedWithPayment isNewCard:', isNewCard)
    if (isNewCard) {
      postDataRef.current = {
        ...postDataRef.current,
        pan: cardNumber,
        name: cardHolderName,
        cvv: cvv,
        expdate: expiry,
        isSaveCard: isSaveCard,
        cardType: 'FOODCARD',
      }
    } else {
      postDataRef.current = {
        ...postDataRef.current,
        pan: cardNumber,
        name: cardHolderName,
        cvv: cvv,
        expdate: expiry,
        cardType: 'FOODCARD',
        token: token,
        type: type,
        scheme: scheme,
      }
    }
    handleProceed(isSaveCard, isNewCard)
  }

  const addPaymentParams = (isSavedCardChecked: boolean) => {
    const postData = postDataRef.current
    const [expmon, expyr] = postData?.expdate.split('/')
    const newCard = {
      number: postData?.pan,
      type: postData?.cardType,
      cvv: String(postData?.cvv),
      subType: String(PAYMENT_MODE_SUBTYPES.FOOD_CARD),
      ownerName: postData?.name,
      expmon: Number(expmon),
      expyr: Number(expyr),
      expDate: postData?.expdate,
      id: 0,
      scheme: '',
      isSave: isSavedCardChecked,
      paymentType: 'Card',
    } as CardType
    addCardPaymentMethod(newCard)
  }

  const handleProceed = async (isSavedCardChecked: boolean, isNewCard: boolean) => {
    console.log('FoodCard handleProceed', isSavedCardChecked, isNewCard)
    const postData = postDataRef.current
    if (isNewCard) {
      if (isSavedCardVisible && isSavedCardChecked) {
        addPaymentParams(isSavedCardChecked)
      } else {
        addPaymentParams(false)
      }
      loadProcessingScreen()
    } else {
      console.log('FoodCard postData', postData)
      const [expmon, expyr] = postData?.expdate?.split('/')
      const newCard = {
        number: postData?.pan,
        type: postData?.cardType,
        subType: postData?.type.toString(),
        cvv: String(postData?.cvv),
        scheme: postData?.scheme.toString(),
        token: postData?.token,
        ownerName: postData?.name,
        expmon: Number(expmon),
        expyr: Number(expyr),
        expDate: postData?.expdate,
        id: 0,
        paymentType: 'Card',
      } as CardType
      console.log('FoodCard newCard', newCard)
      addCardPaymentMethod(newCard)

      console.log('FoodCard b4 loadProcessingScreen')
      loadProcessingScreen()
    }
  }

  useEffect(() => {
    if (savedCards.length && !prevLength) {
      setPrevLength(savedCards.length)
    }
  }, [savedCards.length, prevLength])

  const NavigateToMerchant = useCallback(() => {
    // Linking.openURL(retUrl)
    // window.location.href = redirectUrl
    if (isIFrame()) {
      window.parent.postMessage(
        {
          txnId: 0,
          intentId,
          status: 'completed',
          message: '',
          rUrl: redirectUrl,
        },
        '*',
      )
    } else {
      //Linking.openURL(retUrl)
      window.location.href = redirectUrl
    }
  }, [intentId, redirectUrl])

  const onChangePayMethod = () => {
    if (isSinglePaymentModeAllowed()) {
      setIsDisabled(true)
      NavigateToMerchant()
    } else if (canGoBack()) {
      goBack()
    }
  }

  const handleback = () => {
    if (canGoBack()) {
      goBack()
    }
  }

  const style = styles(theme)

  const renderLoader = () => {
    return (
      <>
        <Header
          title={staticStrings.sodexoHeader}
          hide={isValidTemplate(template.id)}
          onGoBack={handleback}
          showGoBack={true}
          theme={theme}
        />
        <Box type={'fullFlexJustifyAlignCenter'}>
          <Loader color={theme?.brandColor as ColorOptions} />
        </Box>
      </>
    )
  }

  const handleAddNewFoodCard = () => {
    lazyInsrtumentsApi(PAYMENT_MODE_SUBTYPES.FOOD_CARD)
  }

  if (errMsg) {
    return (
      <>
        <Box flex={1} {...style.centerAlignment}>
          <Pluxee width={72} height={24} />
          <Spacer direction={'vertical'} size={16} />
          <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} fontWeight="700">
            {staticStrings.sodexoPayUsing}
          </Text>
          <Box justifyContent="center" alignItems="center" width={'100%'}>
            <Spacer direction="vertical" size={32} />
            <Icon id="INFO" size={48} color={theme?.bodyTextColor as ColorOptions} />
            <Spacer direction="vertical" size={16} />
            <Box paddingHorizontal={32}>
              <Text
                textAlign="center"
                title={errMsg}
                fontSize={14}
                fontWeight="700"
                color={theme?.bodyTextColor as ColorOptions}
              />
            </Box>
            <Spacer direction="vertical" size={36} />
          </Box>

          <Box width="100%" paddingHorizontal={32}>
            <Button
              disabled={isDisabled}
              type="secondary"
              isFull={true}
              title={isSinglePaymentModeAllowed() ? 'Go back to merchant' : 'Change Payment method'}
              onPress={onChangePayMethod}
            />
          </Box>
        </Box>
      </>
    )
  }

  const onClickGetBalance = (item: CardData) => {
    getCardBalance(item.token)
  }

  const renderContent = () => {
    if (showPaymentProcessModal) {
      if (noSavedCards || isAddNewFoodCard) {
        updateHeaderClose(false)
        return <FoodCardFullScreenProcessing />
      } else {
        return (
          <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} isFoodCard={true} />
        )
      }
    }

    const SCHeader = () => {
      return (
        <Box {...style.infoContainer}>
          <Icon color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} id="INFO" size={14} />
          <Spacer direction="horizontal" size={10} />
          <Text {...style.infoText}>
            Shown below is the consolidated balance of all cards registered with same mobile number
          </Text>
        </Box>
      )
    }
    return (
      <>
        <Header
          title={staticStrings.sodexoHeader}
          hide={isValidTemplate(template.id)}
          onGoBack={handleback}
          showGoBack={true}
          theme={theme}
        />
        <Box nativeID="showListScrollBar" {...style.superView}>
          <Box height={'100%'} flex={1}>
            <CreditCard
              savedCards={savedCards}
              amount={amount}
              isLoading={(savedCardsState === 'pending' || instrumentsApiState === 'pending') ?? false}
              onPayment={proceedWithPayment}
              scHeaderComp={<SCHeader />}
              isValid={false}
              theme={theme}
              showAddeNew={showAddeNew}
              onClickGetBalance={onClickGetBalance}
              onModalState={(modelState: any) => {
                setShowAddeNew(modelState)
                updateModalDisplaying(modelState)
                console.log('FoodCard modelState', modelState)
                if (modelState) {
                  setIsAddNewFoodCard(true)
                  handleAddNewFoodCard()
                }
              }}
              onSaveCardVisible={setIsSavedCardVisible}
              isFoodCard={true}
            />
          </Box>
        </Box>
      </>
    )
  }

  const savedCardStatus = savedCardApiStatus === 'initial' || savedCardApiStatus === 'pending'

  return savedCardStatus || instrumentsApiState === 'pending' ? renderLoader() : renderContent()
}

export default FoodCard
